import React, { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider, Drawer, useMediaQuery, Box } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { Routes, Route, useLocation } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Dashboard from "./scenes/dashboard";
import Sidebar from "./scenes/global/Sidebar";
import LeaguePage from "./scenes/league";
import KeeperSettings from "./scenes/keepers/KeeperSettings";
import KeeperTeams from "./scenes/keepers";
import PlayersTable from "./scenes/players";
// import Line from "./scenes/line";
import Draftboard from "./scenes/draftboard";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ToastProvider } from "./contexts/ToastContext";
import { SleeperModalProvider } from "./contexts/SleeperModalContext";
import SplashPage from "./scenes/global/SplashPage";

import { SignedIn, SignedOut } from "@clerk/clerk-react";

function App() {
  const location = useLocation();
  const [theme, colorMode] = useMode();
  // Check if we're on the draftboard page
  const isDraftboardPage = location.pathname === "/draftboard";

  // Responsive layout
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

  // When viewport crosses md, close mobile drawer and set mini variant
  useEffect(() => {
    if (isMdUp) {
      setMobileSidebarOpen(false);
      setSidebarCollapsed(true); // mini with icons
    }
  }, [isMdUp]);

  // const [isSidebar, setIsSidebar] = useState(!isDraftboardPage);
  // const [sidebarHidden, setSidebarHidden] = useState(true); // Start collapsed
  // const [ownerNames, setOwnerNames] = useState([]);

  useEffect(() => {
    document.title = "WeezDraftboard";
  }, []);

  // useEffect(() => {
  //   fetch("http://localhost:8000/api/owners")
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setOwnerNames(data);
  //       console.log("Owners: ", data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching owner names:", error);
  //     });
  // }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <SettingsProvider>
          <ToastProvider>
            <SleeperModalProvider>
              <CssBaseline />
            <div className="app">
              <SignedIn>
                {/* Sidebar region */}
                {isMdUp ? (
                  <Box sx={{ flexShrink: 0 }}>
                    <Sidebar
                      initialCollapsed={sidebarCollapsed}
                      onToggleCollapse={() => setSidebarCollapsed((v) => !v)}
                      onNavigate={() => { /* no-op on desktop */ }}
                    />
                  </Box>
                ) : (
                  <Drawer
                    open={mobileSidebarOpen}
                    onClose={() => setMobileSidebarOpen(false)}
                    variant="temporary"
                    ModalProps={{ keepMounted: false }}
                    PaperProps={{ sx: { width: 260 } }}
                  >
                    <Sidebar
                      initialCollapsed={false}
                      onToggleCollapse={() => {}}
                      onNavigate={() => setMobileSidebarOpen(false)}
                      isMobile
                    />
                  </Drawer>
                )}
              </SignedIn>

              <main className="content" style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100vh', 
                overflow: isDraftboardPage ? 'hidden' : 'auto' 
              }}>
                <SignedIn>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    height: '100%', 
                    minHeight: 0, 
                    overflow: isDraftboardPage ? 'hidden' : 'visible' 
                  }}>
                    <Topbar
                      isDraftboardPage={isDraftboardPage}
                      onOpenSidebar={() => setMobileSidebarOpen(true)}
                    />
                    <Box sx={{ 
                      flex: 1, 
                      minHeight: 0, 
                      overflow: isDraftboardPage ? 'hidden' : 'auto', 
                      display: 'flex', 
                      flexDirection: 'column', 
                      height: isDraftboardPage ? '100%' : 'auto' 
                    }}>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/draftboard" element={<Draftboard />} />
                        <Route path="/leagues/:leagueId" element={<LeaguePage />} />
                        <Route path="/leagues/:leagueId/keepers" element={<KeeperTeams />} />
                        <Route path="/leagues/:leagueId/keeper-settings" element={<KeeperSettings />} />
                        <Route path="/keepers" element={<KeeperTeams />} />
                        {/* <Route path="/owners/:ownerId" element={<KeeperRoster />} /> */}
                        <Route path="/players" element={<PlayersTable />} />
                        {/* <Route path="/line" element={<Line />} />*/}
                      </Routes>
                    </Box>
                  </Box>
                </SignedIn>
                <SignedOut>
                  {/* Optional signed-out body content */}
                  <SplashPage />
                </SignedOut>
              </main>
            </div>
            </SleeperModalProvider>
          </ToastProvider>
        </SettingsProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
